import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_CONSTANT } from '../../constants/application.constant';



@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private httpOptions1 = {
    headers: new HttpHeaders({
      observe : 'body',  
      responseType : 'text' as 'text',  
      Accept: 'text/plain, */*', 
      'Skip-Auth': 'true'  
    }),
  };

  constructor(private readonly http: HttpClient) { }
  

  getUserInfo(url: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Skip-Auth': 'false',
        'OHID-Auth': 'true'
      }),
    }
    return this.http.get(`${APP_CONSTANT.BASE_URL}${url}`, httpOptions)
      .pipe(catchError(this.handleError));
  }

  post(path: string, payload: any, useOHIDToken: boolean = false): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 
        'Content-Type': 'application/json',
        'OHID-Auth': useOHIDToken ? 'true' : 'false'
      })
    }
    return this.http
    .post( `${APP_CONSTANT.BASE_URL}${path}`, payload, httpOptions)
    .pipe(catchError(this.handleError));
  }

  authPost(path: string, payload: any, skipAuthentication: boolean = false): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Skip-Auth': skipAuthentication ? 'true' : 'false'
      }),
    }
    return this.http.post(`${APP_CONSTANT.BASE_URL}${path}`, payload, httpOptions)
    .pipe(catchError(this.handleError));
  }

  authToken(url: string, payload: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Skip-Auth': 'true'
      }),
    };
    const params = new HttpParams({
      fromObject: payload
    });
    return this.http.post(url, params, httpOptions);
  }

  // Error handling
  private handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}, Message: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return {errorMessage, statusCode: error.status};
    });
  }
}
